import { Injectable } from '@angular/core';
import axios, { AxiosResponse } from 'axios';
import { environment } from './../../environments/environment';
import { Parametros, Method } from './../shared/interfaces'
import { isNil } from 'lodash';
import { StorageService } from '../services/storage.service';
import { ToastService } from 'angular-toastify';

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  private readonly urlBase: string = '';

  constructor(
    protected storage: StorageService, 
    private readonly ntf: ToastService) {
    this.urlBase = environment.apiUrl;
  }

  public async consulta(path: string, auth: boolean = false, params: Parametros[] = [], data: any = null, metodo: Method = 'GET', file: boolean = false): Promise<any> {
    const firstCharacter = path[0]
    if (firstCharacter == '/') {
      path = path.substring(1, path.length)
    }

    const ultimoCaracterPath = path[-1]
    if (ultimoCaracterPath != '/') {
      path += '/'
    }

    const token = this.storage.token?.token || ''

    if (isNil(token) && auth) {
      this.ntf.info(`No se encuentra logueado.`)
    }

    const headers = {
      'Authorization': auth ? `Bearer ${token}` : '',
      'Content-Type': !file ? 'application/json' : 'multipart/form-data'
    }

    const parametrosExtra = params.reduce((params: string = '', param: Parametros, index: number): string => {
      return params += params == '' ? ('?' + (isNil(param.valor) ? param.param : `${param.param}=${param.valor}`)) : ('&' + (isNil(param.valor) ? param.param : `${param.param}=${param.valor}`))
    }, '')
    const url = `${this.urlBase}/${path}${parametrosExtra}`

    if (metodo == 'POST' || metodo == 'post') {
      return await axios.post(url, data, { headers: headers });
    }

    if (metodo == 'DELETE' || metodo == 'delete') {
      return await axios.delete(url, { headers: headers })
    }

    if (metodo == 'PATCH' || metodo == 'patch') {
      return await axios.patch(url, data, { headers: headers })
    }

    if (metodo == 'PUT' || metodo == 'put') {
      return await axios.put(url, data, { headers: headers })
    }

    if (metodo == 'GET' || metodo == 'get') {
      return await axios.get(url, { headers: headers })
    }

    return await axios.get(url, { headers: headers })
  }

}
